/* eslint-disable import/prefer-default-export */
import { track } from "common/utils/mixpanel/tracker";
import {
  trackRudderstackImageUploadStarted,
  trackRudderstackImageRemoved,
  trackRudderstackImageUploadCompleted
} from "common/utils/rudderstack/tracker";

export const trackUploadInitiated = (location, mode, file) => {
  track("made_pdp_upload_initiated", { location, mode });

  trackRudderstackImageUploadStarted({
    catalog_number: document.querySelector(".js-quantity-form-input")?.dataset?.catalogNumber,
    location: "print_order_builder",
    file_type: file.type,
    file_size: file.size,
    file_name: file.name,
    dpi: 300,
    business_line: "Print",
    artworks_count: 1
  });
};

export const trackUploadSuccess = (location, file, artwork) => {
  track("made_pdp_upload_success", { location });

  trackRudderstackImageUploadCompleted({
    location: "print_order_builder",
    file,
    artwork,
    dpi: 300,
    business_line: "Print",
    artworks_count: 1
  });
};

export const trackRemoveImage = ({ location, filetype, filesize, filename }) => {
  track("made_pdp_remove_image", { location });
  trackRudderstackImageRemoved({
    file_name: filename,
    file_type: filetype,
    file_size: filesize,
    location: "print_order_builder",
    business_line: "Print",
    artworks_count: 1
  });
};

export const trackCustomPlacementInteraction = payload => {
  track("made_pdp_custom_placement_interaction", payload);
};
